module.exports = __webpack_public_path__ + "img/popup1.35c6e53c.png";